import React from 'react';
import { useDetectClickOutside } from '../hooks/';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PopoverButton = ({
  title,
  buttonChildren,
  popoverChildren,
  className,
  ...rest
}) => {
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible
  } = useDetectClickOutside(false);
  let classNames = ('rgt-columns-manager-wrapper ' + (className || '')).trim();
  return /*#__PURE__*/_jsxs("div", { ...rest,
    ref: ref,
    className: classNames,
    children: [/*#__PURE__*/_jsx("button", {
      className: `rgt-columns-manager-button${isComponentVisible ? ' rgt-columns-manager-button-active' : ''}`,
      onClick: () => setIsComponentVisible(!isComponentVisible),
      children: buttonChildren
    }), /*#__PURE__*/_jsxs("div", {
      className: `rgt-columns-manager-popover${isComponentVisible ? ' rgt-columns-manager-popover-open' : ''}`,
      children: [/*#__PURE__*/_jsx("span", {
        className: "rgt-columns-manager-popover-title",
        children: title
      }), /*#__PURE__*/_jsx("div", {
        className: "rgt-columns-manager-popover-body",
        children: popoverChildren
      })]
    })]
  });
};

export default PopoverButton;